<div class="control-card-header">
    <div id="headerConfirm">
        <ng-container i18n="@@send_email_dialog_header">Invio mail benvenuto</ng-container>
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
    </div>
</div>

<div class="control-card-content">
    <form [formGroup]="emailDataForm">
        <table class="simple-table">

            <tr>
                <td  class="text-dark" i18n="@@send_email_dialog_toEmail">Destinatario :</td>
                <td ><input id="toEmail-input" formControlName="toEmail" type="text" [(ngModel)]="toEmail" /></td>
                <td  class="text-dark" i18n="@@send_email_dialog_ccEmail">Email in CC :</td>
                <td ><input id="ccEmail-input" formControlName="ccEmail" type="text" [(ngModel)]="ccEmail" /></td>
            </tr>
            <tr>
                <td  class="text-dark" i18n="@@send_email_dialog_subject">Oggetto :</td>
                <td colspan="3"><input id="subject-input" formControlName="subject" type="text" [(ngModel)]="subject" /></td>
            </tr>

        </table>
    </form>

    <angular-editor [(ngModel)]="htmlContent" [config]="editorConfig"></angular-editor>
    <br>

    <a (click)="sendEmailControls()" class="button" id="sendEmailButton">
        <ng-container i18n="@@send_email_dialog_send">Invia</ng-container>
        <span>
            <fa-icon icon="share-square"></fa-icon>
        </span>
    </a>



    <a (click)="closeDialog()" class="button button-red" id="cancelButton">
        <ng-container i18n="@@accessMethodGuide_cancel">Annulla</ng-container>
        <span>
            <fa-icon icon="times"></fa-icon>
        </span>
    </a>

    <br>
    <p class="text-small text-error" *ngIf="toEmailInvalidError" i18n="@@send_email_dialog_toEmailInvalidError">
        La mail di destinazione non é valida
    </p>

    <p class="text-small text-error" *ngIf="ccEmailInvalidError" i18n="@@send_email_dialog_ccEmailInvalidError">
        La mail in cc non é valida
    </p>

    <p class="text-small text-error" *ngIf="subjectInvalidError" i18n="@@send_email_dialog_subjectInvalidError">
        Oggetto della mail mancante
    </p>

    <p class="text-small text-error" *ngIf="htmlContentInvalidError" i18n="@@send_email_dialog_htmlContentInvalidError">
        Contenuto della mail mancante
    </p>

    <p class="text-small text-error" *ngIf="codeNotPresent" i18n="@@send_email_dialog_codeNotPresent">
        Il contenuto della mail non contiene il codice di attivazione
    </p>


    <p class="text-small text-error" *ngIf="errorDuringSending" i18n="@@send_email_dialog_errorDuringSending" style="margin-top: -15px;">
        Si é verificato un errore durante l'Invio <br> Controllare i dati inseriti e riprovare più tardi.
    </p>



</div>